import { Injectable, signal } from '@angular/core';

export interface ToastMessage {
  id: number;
  type: 'cart' | 'info' | 'warning';
  productName?: string;
  productCode?: string;
  message?: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 0;
  toasts = signal<ToastMessage[]>([]);

  show(productName: string, productCode: string): void {
    const id = ++this.nextId;
    this.toasts.update(t => [...t, { id, type: 'cart', productName, productCode }]);
    setTimeout(() => this.dismiss(id), 4000);
  }

  showInfo(message: string): void {
    const id = ++this.nextId;
    this.toasts.update(t => [...t, { id, type: 'info', message }]);
    setTimeout(() => this.dismiss(id), 3000);
  }

  showWarning(message: string): void {
    const id = ++this.nextId;
    this.toasts.update(t => [...t, { id, type: 'warning', message }]);
    setTimeout(() => this.dismiss(id), 5000);
  }

  dismiss(id: number): void {
    this.toasts.update(t => t.filter(toast => toast.id !== id));
  }
}
